import React from "react";
import versionInfo from "../version.json";

/**
 * VersionBadge — small deploy identifier shown in the sidebar footer.
 *
 * The bundled `src/version.json` is written by deploy.sh at deploy time
 * (short git SHA + build timestamp). In local dev the committed default
 * reads `sha: "dev"` so the badge shows "dev" instead of crashing.
 *
 * Clicking copies the full SHA to the clipboard — lets you paste it into
 * a Slack release-note thread when people ask "what version?".
 */
export default function VersionBadge({ collapsed }) {
  const { sha, fullSha, builtAt, branch } = versionInfo || {};

  const isDev = !sha || sha === "dev" || sha === "unknown";
  // Shown on hover. Full SHA, branch, and build timestamp for forensic clarity.
  const tooltip = isDev
    ? "Running a dev build (no deploy SHA captured)"
    : [
        `Commit: ${fullSha || sha}`,
        branch && branch !== "unknown" ? `Branch: ${branch}` : null,
        builtAt ? `Built: ${new Date(builtAt).toLocaleString()}` : null,
        "",
        "Click to copy the full SHA.",
      ].filter(Boolean).join("\n");

  const copy = () => {
    if (isDev) return;
    try {
      navigator.clipboard?.writeText(fullSha || sha);
    } catch { /* best-effort */ }
  };

  // When the sidebar is collapsed, show just the first 4 chars to fit.
  const label = collapsed ? (sha || "dev").slice(0, 4) : (sha || "dev");

  return (
    <button
      type="button"
      className={`sidebar-version ${isDev ? "sidebar-version-dev" : ""}`}
      title={tooltip}
      onClick={copy}
    >
      {!collapsed && <span className="sidebar-version-label">v</span>}
      <span className="sidebar-version-sha">{label}</span>
    </button>
  );
}
